import { module } from "angular";
import { isObject, isArray} from 'underscore';

export class ModuleUtils {
    public static CreateModule(options: ngExtendedType.IModuleOptions): ng.IModule {

        let appModule = module(options.name, options.injectModules);

        if (options.states || options.defaultUrl) {
            appModule.config(['$stateProvider', '$urlRouterProvider', ($stateProvider: angular.ui.IStateProvider, $urlRouterProvider: angular.ui.IUrlRouterProvider) => {
                if (isArray(options.states))
                    options.states.forEach(state => $stateProvider.state(state));

                if (options.defaultUrl) {
                    $urlRouterProvider.otherwise(function () {
                        return options.defaultUrl;
                    });
                }
            }]);
        }

        if (isObject(options.providers))
            Object.keys(options.providers).forEach(name => {
                appModule.provider(name, options.providers[name])
            });

        if (isObject(options.constants))
            Object.keys(options.constants).forEach(name => {
                appModule.constant(name, options.constants[name])
            });

        if (isObject(options.components))
            Object.keys(options.components).forEach(name => {
                appModule.component(name, options.components[name])
            });

        if (isObject(options.controllers)) {
            Object.keys(options.controllers).forEach(name => {
                appModule.controller(name, options.controllers[name])
            });
        }

        if (isObject(options.directives))
            Object.keys(options.directives).forEach(name => appModule.directive(name, options.directives[name]));

        if (isObject(options.services))
            Object.keys(options.services).forEach(name => appModule.service(name, options.services[name]));

        if (isObject(options.filters))
            Object.keys(options.filters).forEach(name => appModule.filter(name, options.filters[name]));

        if (isArray(options.configBlocks))
            options.configBlocks.forEach(configBlock => appModule.config(configBlock));

        if (isArray(options.runBlocks))
            options.runBlocks.forEach(runBlock => appModule.run(runBlock));

        return appModule;
    }
}